import { FC, SVGProps } from 'react';

const FilterSettingIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 18,
  color = '#7A7A7A',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0639 10.2744C13.2885 10.2744 14.2797 11.267 14.2797 12.4908C14.2797 13.7154 13.2885 14.7078 12.0639 14.7078C10.8393 14.7078 9.84717 13.7154 9.84717 12.4908C9.84717 11.267 10.8393 10.2744 12.0639 10.2744Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.13767 3.29224C8.36225 3.29224 9.35473 4.28473 9.35473 5.5093C9.35473 6.73313 8.36225 7.72563 7.13767 7.72563C5.91311 7.72563 4.9209 6.73319 4.9209 5.50936C4.9209 4.28479 5.91311 3.29224 7.13767 3.29224Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.75 5.51001H4.92109M9.3536 5.51001H16.25"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.75 12.491H9.8471M14.2796 12.491H16.25"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default FilterSettingIcon;
